import api from './api';

export type GatewayRemoteFolder = 'desktop' | 'downloads' | 'documents' | 'gateway';

export const GATEWAY_REMOTE_FOLDERS: { id: GatewayRemoteFolder; label: string }[] = [
  { id: 'desktop', label: '바탕화면' },
  { id: 'downloads', label: '다운로드' },
  { id: 'documents', label: '문서' },
  { id: 'gateway', label: '게이트웨이 실행 폴더' },
];

export function gatewayRemoteFolderLabel(folder: string | undefined): string {
  return GATEWAY_REMOTE_FOLDERS.find((item) => item.id === folder)?.label || '바탕화면';
}

export type GatewayRemoteProduct = 'data_gateway' | 'control_room';

export type GatewayRemoteSession = {
  id: string;
  ticket: string;
  product: GatewayRemoteProduct;
  pool_id: number | null;
  state: string;
};

export async function createGatewayRemote(body: {
  product: GatewayRemoteProduct;
  pool_id?: number | null;
}): Promise<GatewayRemoteSession> {
  const res = await api.post<{ ok: boolean; session: GatewayRemoteSession }>(
    '/api/gateway-remote/sessions',
    body,
  );
  return res.session;
}

export async function endGatewayRemote(sessionId: string): Promise<void> {
  await api.delete(`/api/gateway-remote/sessions/${encodeURIComponent(sessionId)}`);
}

export async function setGatewayRemoteTalk(
  sessionId: string,
  body: {
    enabled: boolean;
    local_mic: boolean;
    local_speaker: boolean;
    remote_mic: boolean;
    remote_speaker: boolean;
  },
): Promise<void> {
  await api.post(`/api/gateway-remote/sessions/${encodeURIComponent(sessionId)}/talk`, body);
}

export async function uploadGatewayRemoteFile(
  sessionId: string,
  file: File,
  folder: GatewayRemoteFolder,
): Promise<{ name: string; folder: GatewayRemoteFolder }> {
  const form = new FormData();
  form.append('file', file);
  form.append('folder', folder);
  const body = await api.post<{ file: { name: string; folder?: GatewayRemoteFolder } }>(
    `/api/gateway-remote/sessions/${encodeURIComponent(sessionId)}/files`,
    form,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 600000,
    },
  );
  return { name: body.file?.name || file.name, folder: body.file?.folder || folder };
}

export function gatewayRemoteViewUrl(sessionId: string, ticket: string): string {
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const q = new URLSearchParams({ ticket });
  return `${proto}//${window.location.host}/api/gateway-remote/sessions/${encodeURIComponent(sessionId)}/view?${q}`;
}
